import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type KioskRemarkMutationPayload = {
  kiosk_communication_id: number;
  remark_id: number;
  handled_remark: boolean;
};

export const useKioskRemarkMutation = () =>
  useTypedMutation<KioskRemarkMutationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/dashboard/remark/handle", payload, ENV.kioskBaseURL);
    },
    onSuccess: ({ kiosk_communication_id, remark_id, handled_remark }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.kiosk_communications?.length) return;

      const kioskCommIdx = appointment.kiosk_communications.findIndex(kc => kc.id === kiosk_communication_id);
      if (kioskCommIdx < 0 || appointment.kiosk_communications[kioskCommIdx].remark?.id !== remark_id) return;

      const kiosk_communications = appointment.kiosk_communications.with(kioskCommIdx, {
        ...appointment.kiosk_communications[kioskCommIdx],
        remark: {
          ...appointment.kiosk_communications[kioskCommIdx].remark,
          receptionist_handled: handled_remark
        }
      });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, kiosk_communications });
    }
  });
